<template>
  <div class="d-flex cursor--pointer" @click="$emit('click')">
    <em
      v-if="icon"
      class="mt-1 mr-3"
      :class="`${icon} color-${colorIcon ? colorIcon : color}`"
    />
    <span
      :class="[
        `text-border__bottom--${color}`,
        { 'border-bottom': withBorder },
        textColor,
      ]"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CustomLink',
  props: {
    icon: {
      type: String,
      default: () => null,
    },
    colorIcon: {
      type: String,
      default: () => null,
    },
    text: {
      type: String,
      required: true,
    },
    textColor: {
      type: String,
      default: () => '',
    },
    color: {
      type: String,
      default: () => 'green',
    },
    withBorder: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>
